'use client';

import { CheckCircleRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';
import type { FC } from 'react';
type Props = {
  name: string | undefined;
  redirectTo: string | undefined;
  order?: number;
  disabled?: boolean;
};
export const CustomItem: FC<Props> = (props: Props) => {
  const {
    name,
    redirectTo,
    order = 3,
    disabled = false
  } = props;
  if (!name || !redirectTo) {
    return null;
  }
  return <MenuItem component="a" href={redirectTo} target="_blank" sx={{
    order,
    paddingY: 2
  }} disabled={disabled} data-sentry-element="MenuItem" data-sentry-component="CustomItem" data-sentry-source-file="custom-item.tsx">
      <ListItemIcon sx={{
      minWidth: 'auto'
    }} data-sentry-element="ListItemIcon" data-sentry-source-file="custom-item.tsx">
        <CheckCircleRounded color="primary" data-sentry-element="CheckCircleRounded" data-sentry-source-file="custom-item.tsx" />
      </ListItemIcon>
      <ListItemText sx={{
      flex: 1
    }} data-sentry-element="ListItemText" data-sentry-source-file="custom-item.tsx">
        <Typography display="inline" data-sentry-element="Typography" data-sentry-source-file="custom-item.tsx">{name}</Typography>
      </ListItemText>
    </MenuItem>;
};